import { getSnapshot, types } from 'mobx-state-tree'

import { FormStringFieldModel } from '../FormField/FormFieldModel'
import { IFormValidation } from '../FormField/FormValidation'

export const BillingAddressModel = types
  .model('BillingAddressModel', {
    street: FormStringFieldModel,
    street2: FormStringFieldModel,
    postalCode: FormStringFieldModel,
    city: FormStringFieldModel,
    state: FormStringFieldModel,
    country: FormStringFieldModel,
    countryCode: FormStringFieldModel,
  })
  .actions((self) => ({
    update(name, value) {
      self[name].setValue(value)
    },
    validate(): void {
      const billingAddress = getSnapshot(self)
      Object.keys(billingAddress).forEach((field) => {
        self[field].isDirty = true
      })
    },
    reset(): void {
      const billingAddress = getSnapshot(self)
      Object.keys(billingAddress).forEach((field) => {
        self[field].isDirty = false
      })
    },
  }))
  .views((self) => ({
    validateStreet(): IFormValidation {
      return {
        isInvalid: self.street.isDirty && !self.street.value.length,
        message: 'directory-validation_street',
      }
    },
    validatePostalCode(): IFormValidation {
      return {
        isInvalid: self.postalCode.isDirty && !self.postalCode.value.length,
        message: 'directory-validation_postal_code',
      }
    },
    validateCity(): IFormValidation {
      return {
        isInvalid: self.city.isDirty && !self.city.value.length,
        message: 'directory-validation_city',
      }
    },
    validateCountry(): IFormValidation {
      return {
        isInvalid: self.countryCode.isDirty && !self.countryCode.value.length,
        message: 'directory-validation_country',
      }
    },
  }))
  .views((self) => ({
    get isValid(): boolean {
      const validationField = ['validateStreet', 'validatePostalCode', 'validateCity', 'validateCountry']
      return (
        self.street.isDirty &&
        self.postalCode.isDirty &&
        self.city.isDirty &&
        self.country.isDirty &&
        validationField.every((field) => !self[field]().isInvalid)
      )
    },
  }))

export interface IBillingAddress {
  street: string
  street2?: string
  postalCode: string
  city: string
  state?: string
  country: string
  countryCode: string
}
